export const ProjectSection = {
  extends: 'Grid',
  childExtends: 'ProjectInfo',
  templateColumns: (el) => (el.getRootState().package > 1 ? '5fr 2fr' : '1fr'),
  gap: 'A',
  align: 'stretch flex-start',
  Stats: {
    Title: {
      text: '{{ editor.project.company | polyglot }}'
    },
    ItemPreview: {
      gap: 'B',
      align: 'flex-start space-between',
      Strong: {
        margin: 'W - -',
        text: '{{ title }}'
      },
      Grid: {
        templateColumns: '2fr 1fr 1fr 1fr',
        width: '100%',
        childExtends: {
          extends: 'Hgroup',
          margin: '0',
          H: {
            tag: 'strong',
            text: '{{ title }}'
          },
          P: {
            text: (el, s) => el.call('polyglot', s.p || '')
          }
        },
        children: (el) => [
          {
            title: el.call(
              'polyglot',
              el.getRootState().package > 1 ? 'editor.project.premium' : 'editor.project.starter'
            ),
            p: 'editor.project.packageLabel'
          },
          {
            title: `1.${el.getRootState().version}`,
            p: 'editor.addDependency.version'
          },
          {
            title: el.getRootState().versionscount,
            p: 'editor.project.publishes'
          },
          {
            title: el.call('formatDate', el.getRootState().createdAt),
            p: 'editor.project.userSince'
          }
        ],
        childrenAs: 'state'
      }
    }
  },
  Team: {
    Title: {
      text: '{{ shell.app.team | polyglot }}'
    },
    ItemPreview: {
      AvatarBundle: {
        extends: 'AvatarBundle',
        fontSize: 'Y2',
        options: (el, s) => {
          const projectUsers = el.getRootProjectsUsers()
          const filtered = el.call('isArray', projectUsers)
            ? projectUsers.filter((v) => (v.role || 0) > -1)
            : projectUsers
          return filtered
            ?.filter((v) => !v.email?.endsWith('@symbo'))
            .map((v) => ({
              key: v.name,
              title: v.name
            }))
        },
        childProps: {
          ':not(:last-child)': {
            margin: '0 -Z 0 0'
          }
        }
      },
      SectionHeader_last_connected: {
        margin: '0',
        title: (el) => {
          const projectUsers = el.getRootProjectsUsers()
          const usersCount = projectUsers?.filter((v) => (v.role || 0) > -1).length
          return `${usersCount} members`
        },
        p: (el) => {
          const projectUsers = el.getRootProjectsUsers()
          const usersCount = projectUsers?.filter((v) => (v.role || 0) > -1).length
          const left = 5 - usersCount < 0 ? 0 : usersCount
          return el.call('polyglot', 'editor.project.inviteLeft').replace('{count}', left)
        }
      }
    }
  }
}
